module.exports = __webpack_public_path__ + "media/images/favicon-fea23c595fdaa7411978585a1e29fd96.ico";